export default {"src":"/_next/static/media/1.084835a5.svg","height":171,"width":304,"blurWidth":0,"blurHeight":0};